// material-ui
import { Components, Theme } from '@mui/material/styles';

// third party
import { merge } from 'lodash-es';

// project imports
import Chip from './Chip';
import Alert from './Alert';

// ===============================||  OVERRIDES - MAIN  ||=============================== //

export default function ComponentsOverrides(theme: Theme) {
  return merge(Chip(theme), Alert(theme)) as Components;
  // return merge(Alert(theme));
}
